// extracted by mini-css-extract-plugin
export default {"container":"Marquee_container__u0YXO","scrollWrapper":"Marquee_scrollWrapper__PXrE8","scroll":"Marquee_scroll__qUdzc","image":"Marquee_image__+tp0e"};